import styled from 'styled-components';

const SendSmsButton = styled.button`
	width: 350px;
	color: white;
	border-radius: 15px;
	border: none;
	background-color: #385dfd;
	font-size: 15px;
	padding: 8px 25px;
	font-weight: 600;
	cursor: pointer;

	&:disabled {
		background-color: grey;
		cursor: not-allowed;
	}

	@media (max-width: 992px) {
		width: 100%;
	}
`;

export default SendSmsButton;
